import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const VbNet = () => {
  return (
    <StartInterviewLayout type="vbdotnet"/>
  )
}

export default VbNet;